<script setup lang="ts">
import { DisciplineScheduleFlow, DisciplineScheduleStep } from '../model/enums'
import { useDisciplineScheduleModals } from '../model/discipline-schedule-modals.hook'
import ModalDisciplineScheduleAssign from './modals/ModalDisciplineScheduleAssign.vue'
import ModalDisciplineScheduleChangeConfirm from './modals/ModalDisciplineScheduleChangeConfirm.vue'
import ModalDisciplineScheduleCreateConfirm from './modals/ModalDisciplineScheduleCreateConfirm.vue'
import ModalDisciplineScheduleEffectiveDate from './modals/ModalDisciplineScheduleEffectiveDate.vue'
import ModalDisciplineScheduleFilters from './modals/ModalDisciplineScheduleFilters.vue'
import ModalDisciplineSchedulePace from './modals/ModalDisciplineSchedulePace.vue'
import ModalDisciplineScheduleSlots from './modals/ModalDisciplineScheduleSlots.vue'
import ModalDisciplineScheduleStartDate from './modals/ModalDisciplineScheduleStartDate.vue'
import ModalDisciplineSetupLessons from './modals/ModalDisciplineSetupLessons.vue'
import ModalDisciplineTutorChangeConfirm from './modals/ModalDisciplineTutorChangeConfirm.vue'
import ModalDisciplineTutorChangeReason from './modals/ModalDisciplineTutorChangeReason.vue'

defineOptions({
  name: 'DisciplineScheduleModals',
})

const {
  refFlow,
  refStep,
} = useDisciplineScheduleModals()
</script>

<template>
  <ModalDisciplineTutorChangeReason v-if="refStep === DisciplineScheduleStep.TutorReason" />
  <ModalDisciplineScheduleSlots v-else-if="refStep === DisciplineScheduleStep.Slots" />
  <ModalDisciplineScheduleStartDate v-else-if="refStep === DisciplineScheduleStep.StartDate" />
  <ModalDisciplineScheduleEffectiveDate v-else-if="refStep === DisciplineScheduleStep.EffectiveDate" />
  <ModalDisciplineSchedulePace v-else-if="refStep === DisciplineScheduleStep.Pace" />
  <ModalDisciplineScheduleFilters v-else-if="refStep === DisciplineScheduleStep.Filters" />
  <ModalDisciplineScheduleAssign v-else-if="refStep === DisciplineScheduleStep.AssignTutor" />
  <ModalDisciplineSetupLessons v-else-if="refStep === DisciplineScheduleStep.SetupLessons" />
  <template v-else-if="refStep === DisciplineScheduleStep.Confirm">
    <ModalDisciplineScheduleCreateConfirm v-if="refFlow === DisciplineScheduleFlow.Create" />
    <ModalDisciplineScheduleChangeConfirm v-else-if="refFlow === DisciplineScheduleFlow.Change" />
    <ModalDisciplineTutorChangeConfirm v-else-if="refFlow === DisciplineScheduleFlow.ChangeTutor" />
  </template>
</template>
